var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotificationIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.111,
    height: 19.3,
    viewBox: "0 0 21.107 20.296",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "notificationIcon",
    transform: "translate(26.923 -1.499)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_5143",
    "data-name": "Rectangle 5143",
    d: "M0,0H6.624a0,0,0,0,1,0,0V0A3.312,3.312,0,0,1,3.312,3.312h0A3.312,3.312,0,0,1,0,0V0A0,0,0,0,1,0,0Z",
    transform: "translate(-19.682 17.983)",
    fill: "none",
    stroke: "var(--mainColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_5144",
    "data-name": "Rectangle 5144",
    d: "M7.828,0h0a7.828,7.828,0,0,1,7.828,7.828v8.156a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V7.828A7.828,7.828,0,0,1,7.828,0Z",
    transform: "translate(-24.198 1.999)",
    fill: "none",
    stroke: "var(--mainColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_471",
    "data-name": "Line 471",
    x2: 21.107,
    transform: "translate(-26.923 17.983)",
    fill: "var(--bgColor)",
    stroke: "var(--mainColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/notificationIcon.64733310b6bc594ee1d967b01ee023ad.svg";
export { ForwardRef as ReactComponent };